import DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import SingleResponseMessage from 'owa-service/lib/contract/SingleResponseMessage';
import UserConfigurationDictionaryObject from 'owa-service/lib/contract/UserConfigurationDictionaryObject';
import distinguishedFolderId from 'owa-service/lib/factory/distinguishedFolderId';
import serviceUserConfiguration from 'owa-service/lib/factory/serviceUserConfiguration';
import updateUserConfigurationOperation from 'owa-service/lib/operation/updateUserConfigurationOperation';
import updateUserConfigurationOwaRequest from 'owa-service/lib/factory/updateUserConfigurationOwaRequest';
import userConfigurationDictionaryEntry from 'owa-service/lib/factory/userConfigurationDictionaryEntry';
import userConfigurationDictionaryObject from 'owa-service/lib/factory/userConfigurationDictionaryObject';
import userConfigurationNameType from 'owa-service/lib/factory/userConfigurationNameType';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

const USER_OPTIONS_BASEFOLDERID_NAME: DistinguishedFolderIdName = 'root';
const VIEW_STATE_CONFIGURATION: string = 'OWA.ViewStateConfiguration';

function updateUserConfigurationService(
    userConfigurationName: string,
    key: UserConfigurationDictionaryObject,
    value: UserConfigurationDictionaryObject
): Promise<SingleResponseMessage> {
    const newUserConfiguration = serviceUserConfiguration({
        UserConfigurationName: userConfigurationNameType({
            Name: userConfigurationName,
            BaseFolderId: distinguishedFolderId({
                Id: USER_OPTIONS_BASEFOLDERID_NAME,
            }),
        }),
        Dictionary: [
            userConfigurationDictionaryEntry({
                DictionaryKey: userConfigurationDictionaryObject(key),
                DictionaryValue: userConfigurationDictionaryObject(value),
            }),
        ],
    });

    return updateUserConfigurationOperation({
        Header: getJsonRequestHeader(),
        Body: updateUserConfigurationOwaRequest({
            UserConfiguration: newUserConfiguration,
        }),
    }).then(response => {
        return response.Body.ResponseMessages.Items[0];
    });
}

export function updateFilePickerViewTypeConfiguration(userConfiguration: OwaUserConfiguration) {
    updateUserConfigurationService(
        VIEW_STATE_CONFIGURATION,
        {
            Type: 'String',
            Value: ['AttachmentsFilePickerViewTypeForMouse'],
        },
        {
            Type: 'Integer32',
            Value: [
                `${userConfiguration.ViewStateConfiguration.AttachmentsFilePickerViewTypeForMouse}`,
            ],
        }
    );
}

export function updateUserPreferenceForCloudFile(userConfiguration: OwaUserConfiguration) {
    updateUserConfigurationService(
        VIEW_STATE_CONFIGURATION,
        {
            Type: 'String',
            Value: ['AttachOrShareCloudFiles'],
        },
        {
            Type: 'Integer32',
            Value: [`${userConfiguration.ViewStateConfiguration.AttachOrShareCloudFiles}`],
        }
    );
}

export function updateUserPreferenceForGroupsFile(userConfiguration: OwaUserConfiguration) {
    updateUserConfigurationService(
        VIEW_STATE_CONFIGURATION,
        {
            Type: 'String',
            Value: ['AttachOrShareGroupsFiles'],
        },
        {
            Type: 'Integer32',
            Value: [`${userConfiguration.ViewStateConfiguration.AttachOrShareGroupsFiles}`],
        }
    );
}
